const printWorkLog = (data) => ({
  method: "POST",
  url: `/manager/work-logs/print`,
  data,
});

export const workLogApi = {
  printWorkLog,
};
